import React, { Component } from "react";
import ExWriterModal from "./ExWriterModal";
import { freelancers } from "./../../../services/employerApplicant";
import AppContext from "../../../contexts/AppContext";

export class ExWriters extends Component {
    componentDidMount() {
        freelancers()
            .then(res => {
                this.setState({ items: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }

    state = {
        showMenu: false,
        showModal: false,
        items: [{ user: {} }]
    };
    toggleMenu = () => {
        this.setState({ showMenu: !this.state.showMenu });
    };
    toggleModal = (id, first_name, last_name) => {
        this.setState({
            showModal: !this.state.showModal,
            id: id,
            first_name: first_name,
            last_name: last_name
        });
    };
    render() {
        return (
            <div class="ExWriters">
                {this.state.showMenu ? (
                    <div class="avatar-group">
                        {this.state.items.map((item, index) => {
                            return (
                                <a
                                    class=" avatar"
                                    onClick={e =>
                                        this.toggleModal(
                                            item.user.id,
                                            item.user.first_name,
                                            item.user.last_name
                                        )
                                    }
                                >
                                    <img
                                        src={item.user.image}
                                        className="avatar-img rounded-circlee"
                                        alt={`${item.user.first_name} ${item.user.last_name}`}
                                    />
                                </a>
                            );
                        })}

                        {this.state.showModal ? (
                            <ExWriterModal
                                last_name={this.state.last_name}
                                first_name={this.state.first_name}
                                id={this.state.id}
                                job_id={this.props.job_id}
                                hideModal={this.toggleModal}
                            ></ExWriterModal>
                        ) : null}
                    </div>
                ) : null}
                <a
                    onClick={this.toggleMenu}
                    className="btn btn-lg btn-rounded-circle btn-white lift"
                    style={{
                        paddingTop: ".7rem",
                        paddingBottom: ".7rem"
                    }}
                    id="users"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-controls="users"
                >
                    +
                </a>
            </div>
        );
    }
}
ExWriters.contextType = AppContext;
export default ExWriters;



// WEBPACK FOOTER //
// ./src/components/employer/workSpace/ExWriters.js